import React, { useEffect, useState } from 'react';
import { BACKEND_URL } from '../../config';

const RISK_USD = 500;

const Tile = ({ label, value, color, bg, testId }) => (
  <div style={{ padding: '1.5rem', background: bg, borderRadius: '12px', textAlign: 'center' }}>
    <div style={{ fontSize: '0.875rem', color, marginBottom: '0.5rem', fontWeight: '600' }}>{label}</div>
    <div data-testid={testId} style={{ fontSize: '2.25rem', fontWeight: '700', color, wordBreak: 'break-word' }}>{value}</div>
  </div>
);

const money = (v) => `${v < 0 ? '−' : v > 0 ? '+' : ''}$${Math.abs(v).toLocaleString('en-US')}`;

// 📊 Protocol Performance from the user V4 Folder: $500 risk per trade, 1:1, PDWD = loss.
export const V4ProtocolPerformance = () => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/user/v4-folder`, { headers: { Authorization: `Bearer ${localStorage.getItem('auth_token')}` } })
      .then((r) => r.json())
      .then((d) => (d.success ? setStats(d.stats) : setError(d.error || 'Could not load V4 Folder performance')))
      .catch(() => setError('Could not connect to the server'));
  }, []);

  const s = stats || { finalized: 0, wins: 0, losses: 0, pending: 0, win_rate: 0 };
  const pnl = (s.wins - s.losses) * RISK_USD;
  const hit = s.win_rate >= 85;

  return (
    <div data-testid="v4-protocol-performance" style={{ padding: '1.5rem', background: 'linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%)', borderRadius: '12px', border: '2px solid #14b8a6' }}>
      <h3 data-testid="v4-perf-title" style={{ fontSize: '1.25rem', color: '#0f766e', marginBottom: '0.5rem' }}>📊 Protocol Performance (V4 Folder)</h3>
      <p data-testid="v4-perf-risk-note" style={{ fontSize: '0.85rem', color: '#334155', marginBottom: '1rem', lineHeight: 1.5 }}>
        Only V4 Folder trades are counted. Every trade risks <strong>$500</strong>. To keep it simple and conservative, P&L uses <strong>1:1</strong>: a win adds <strong>+$500</strong> and a loss takes away <strong>−$500</strong>. Perfect Detection / Wrong Dir counts as a loss. Trades still running are added once they finish.
      </p>
      {error && <div data-testid="v4-perf-error" style={{ color: '#dc2626', fontWeight: 600, marginBottom: '1rem' }}>{error}</div>}
      {!stats && !error && <div data-testid="v4-perf-loading" style={{ color: '#64748b', marginBottom: '1rem' }}>⏳ Loading…</div>}
      <div style={{ padding: '1rem 1.25rem', background: 'rgba(255,255,255,0.85)', borderRadius: '12px', marginBottom: '1rem', border: '1px solid #99f6e4' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.75rem', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '0.875rem', color: '#0f766e', fontWeight: '600' }}>Win Rate</span>
          <span data-testid="perf-win-rate" style={{ fontSize: '2rem', fontWeight: '700', color: hit ? '#16a34a' : '#0f766e' }}>{s.win_rate}% {hit ? '✅' : ''}</span>
          <span style={{ fontSize: '0.8rem', color: '#64748b' }}>({s.wins} wins / {s.finalized} finished · target 85%{s.pending ? ` · ${s.pending} still running` : ''})</span>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '1rem' }}>
        <Tile testId="perf-total-trades" label="Total Trades" value={s.finalized} color="#1e40af" bg="linear-gradient(135deg, #dbeafe 0%, #93c5fd 100%)" />
        <Tile testId="perf-won" label="Winning Trades" value={s.wins} color="#16a34a" bg="linear-gradient(135deg, #dcfce7 0%, #86efac 100%)" />
        <Tile testId="perf-lost" label="Losing Trades" value={s.losses} color="#dc2626" bg="linear-gradient(135deg, #fee2e2 0%, #fca5a5 100%)" />
        <Tile testId="perf-net-pnl" label="Net P&L ($500 risk, 1:1)" value={money(pnl)} color={pnl >= 0 ? '#16a34a' : '#dc2626'} bg={pnl >= 0 ? 'linear-gradient(135deg, #dcfce7 0%, #86efac 100%)' : 'linear-gradient(135deg, #fee2e2 0%, #fca5a5 100%)'} />
      </div>
    </div>
  );
};
